import { get, isEmpty } from 'lodash/fp';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { JsonBlob } from '@portals/ui';

const Response = ({ response }) =>
  !isEmpty(response) ? (
    <Container>
      <h5 data-testid="response-status">
        Status:
        {response.status}
      </h5>
      <JsonBlob json={response.data} height="300px" />
    </Container>
  ) : null;

const Container = styled.div``;

const mapStateToProps = (state, ownProps) => ({
  response:
    get(['data', 'tracking', ownProps.type], state) || ownProps.response || {},
});

export default connect(mapStateToProps)(Response);
